import httpClient from "@plugins/http";
import { DataTableOutput } from "@plugins/common/types.ts";
import { ApiResponse } from "@apis/api.ts";
import { File } from "@modules/my-drive/my-drive-types.ts";
import { MoveFileResponse } from "@modules/my-drive/my-drive-types.ts";

const fetchMyDrive = async (params): Promise<ApiResponse<DataTableOutput<File>>> => {
  return await httpClient.get(`/apis/my-drive/folders?timestamp=${params.timeStamp}`, {
    params: params,
  });
};

const fetchSharedWithMe = async (params): Promise<ApiResponse<DataTableOutput<File>>> => {
  return await httpClient.get(`/apis/my-drive/shared-with-me?timestamp=${params.timeStamp}`, {
    params: params,
  });
};

const getShareCount = async (resourceMap): Promise<ApiResponse<number>> => {
  return await httpClient.post(`/apis/my-drive/get-share-count`, resourceMap);
};

const moveToTrash = async (params): Promise<ApiResponse<MoveFileResponse>> => {
  return await httpClient.post(`/apis/my-drive/delete`, {
    uuids: params,
  });
};

const checkRestore = async (param): Promise<ApiResponse<Record<string, string>>> => {
  return await httpClient.post(`/apis/my-drive/check-restore`, param);
};

const restore = async (param): Promise<ApiResponse<Record<string, string[]>>> => {
  return await httpClient.post(`/apis/my-drive/restore`, param);
};

const permanentDelete = async (param): Promise<ApiResponse<Record<string, object[]>>> => {
  return await httpClient.post(`/apis/my-drive/hard-delete`, param);
};

const fetchSearchResultInMyDrive = async (params): Promise<ApiResponse<DataTableOutput<File>>> => {
  return await httpClient.get(`/apis/my-drive/search?timestamp=${params.timeStamp}`, {
    params: params,
  });
};

const fetchFullResourceNodesTree = async (): Promise<ApiResponse<File[]>> => {
  return await httpClient.get(`/apis/my-drive/structure`);
};

const moveResource = (params): Promise<ApiResponse<MoveFileResponse>> => {
  return httpClient.post(`/apis/my-drive/move`, params);
};
export default {
  fetchMyDrive,
  fetchSharedWithMe,
  fetchSearchResultInMyDrive,
  fetchFullResourceNodesTree,
  getShareCount,
  moveToTrash,
  checkRestore,
  restore,
  permanentDelete,
  moveResource,
  async moveResourceToTrash(params): Promise<ApiResponse<Record<string, unknown>>> {
    return await httpClient.post(`/apis/my-drive/delete-resource`, params);
  },
  copyResource(params) {
    return httpClient.post(`/apis/my-drive/duplicate`, params);
  },
  checkLessonCopied(lessonUuid) {
    return httpClient.get(`/apis/my-drive/check-lesson-copied/${lessonUuid}`);
  },
  createFolder(requestData) {
    return httpClient.post(`/apis/my-drive/folders/create`, null, { params: requestData });
  },
  renameResourceNode(uuid, name) {
    const params = new URLSearchParams();
    params.append("name", name);
    return httpClient.post(`/apis/my-drive/rename/${uuid}`, params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },
};
